import { RejectionReason } from "../redux/onBoardingSlice.types";

/**
 * Resolves a reason key to its display value.
 * When the resolved value is "others" (case-insensitive) and a comment is provided,
 * returns "<value>: <comment>".
 *
 * Pure function — safe to unit-test without any React context.
 */
export const resolveReason = (
  reasonKey: string,
  comment: string,
  reasons: RejectionReason[] = []
): string => {
  const match = reasons.find((r) => r.key === reasonKey);
  const displayValue = match?.value ?? reasonKey;
  return displayValue.toLowerCase() === "others" && comment
    ? `${displayValue}: ${comment}`
    : displayValue;
};
